(function () {
  'use strict';

  angular.module('app').service('ProviderCreditNoteModalService', ProviderCreditNoteModalService);

  ProviderCreditNoteModalService.$inject = ['ModalService'];

  function ProviderCreditNoteModalService(ModalService) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openSendProviderCreditNoteToProvider: openSendProviderCreditNoteToProvider,
    };

    return service;

    ////////////////////////

    // Modal invoice send email
    function openSendProviderCreditNoteToProvider(providerEmail, successCallback) {
      ModalService.showModal({
        templateUrl:
          './app/ajs/provider-credit-notes/modals/send-provider-credit-note-to-provider-modal.html',
        controller: SendProviderCreditNoteToProviderCtrl,
        controllerAs: 'vm',
        inputs: {
          providerEmail: providerEmail,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });
    }

    function SendProviderCreditNoteToProviderCtrl($element, providerEmail, successCallback) {
      var vm = this;

      vm.providerEmail = providerEmail;

      vm.sendProviderCreditNote = sendProviderCreditNote;

      function sendProviderCreditNote(isFormValid) {
        if (!isFormValid) {
          vm.serverErrors = [];
          vm.formErrors = true;
        } else {
          vm.sendingForm = true;

          $element.modal('hide');
          successCallback(vm.clientEmail);
        }
      }
    }
  }
})();
